export class Utils {
    static stringToNumber(str) {
        if(!str) return 0;
        let rs = str.toString().replace(/[.]/g, '').replace(/[,]/g, '.');
        return rs;
    }

    static numberToString(str) {
        let rs = str.toString().replace(/[.]/g, ',');
        return rs;
    }

    static base64ToByteArray(base64String: string): Uint8Array {
        return Uint8Array.from(atob(base64String), (c,i) => c.charCodeAt(i));
    }

    static byteArrayToBlob(byteArray: Uint8Array): Blob {
        return new Blob([byteArray]);
    }

    static blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (e) => reject(e);
            reader.readAsDataURL(blob); 
        })
    }

    static base64ToBlob(base64String): Promise<Blob> {
        /*
        if(!base64String) return null;
        //return Utils.byteArrayToBlob(Utils.base64ToByteArray(base64String));
        let byteString;
        if (base64String.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(base64String.split(',')[1]);
        else
            base64String = unescape(base64String.split(',')[1]);
        // separate out the mime component
        let mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        let ia = new Uint8Array(base64String.length);
        for (var i = 0; i < base64String.length; i++) {
            ia[i] = base64String.charCodeAt(i);
        }
        
        return new Blob([ia], { type: mimeString });
        */

        return fetch(base64String).then( r => r.blob() )
    }
}